<template>
    <span class="text-center text-xl font-medium text-white">
        <span class="flex justify-center w-full text-white mb-1">
            <p class="w-fit text-4xl font-bold align-middle h-full my-auto uppercase">{{ title }}</p>
            
            <GlobeIcon v-if="icon==='GlobeIcon'" class="w-12 h-12 ml-1 inline" />
            <LocationMarkerIcon v-else-if="icon==='LocationMarkerIcon'" class="w-12 h-12 ml-1 inline" />
            <FlagIcon v-else-if="icon=='FlagIcon'" class="w-12 h-12 ml-1 inline"/>
        </span>

        <span class="w-full">
            <span class="bg-gray-500 transition duration-500 ease-in-out dark:bg-gray-900 flex w-full rounded-md">
                <span scope="col" class="px-6 py-2 text-center text-md font-medium text-white" :class="[type === 'global' ? 'w-1/4' : 'w-1/5']">
                    POSITION
                </span>
                <span v-if="type !== 'jockey' && type !== 'team'" scope="col" class="px-6 py-2" :class="[type === 'global' ? 'w-2/4' : 'w-3/5']">
                    USERNAME
                </span>
                <span v-if="type === 'team'" scope="col" class="px-6 py-2" :class="[type === 'global' ? 'w-2/4' : 'w-3/5']">
                    TEAM
                </span>
                <span v-if="type === 'jockey'" scope="col" class="px-6 py-2" :class="['w-3/5']">
                    JOCKEY
                </span>
                <span scope="col" class="px-6 py-2" :class="[type === 'global' ? 'w-1/4' : 'w-1/5']">
                    POINTS
                </span>
                <span v-if="type === 'local' || type === 'team'" scope="col" class="w-1/5 px-6 py-2">
                    JOKER
                </span>
            </span>

            <Player v-if="type === 'local'" v-for="(bet, index) in leaderboard.bets" :type="type" :bet="bet" :index="index" />
            <Player v-else v-for="(bet, index) in leaderboard" :type="type" :bet="bet" :index="index" />
        </span>
    </span>
</template>
  
<script>

import Player from './Player.vue';
import { GlobeIcon, LocationMarkerIcon, FlagIcon } from '@heroicons/vue/outline'

export default {
    name: 'Leaderboard',
    props: {
        title: {
            type: Text,
        },
        icon: {
            type: Text,
        },
        index: {
            type: Number,
            required: true,
        },
        leaderboard: {
            type: Object,
            required: true,
        },
        type: {
            type: Text
        }
    },
    components: {
        GlobeIcon,
        LocationMarkerIcon,
        Player,
        FlagIcon,
    },
}
</script>
